import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
// This file is a modified version of packages/ab-common/src/api/profilePage.ts
import { axiosInstance } from '@applyboard/ui-utils';
export var getGradeSchemes = function getGradeSchemes(payload) {
  var pieces = [];
  var params = payload === null || payload === void 0 ? void 0 : payload.params;
  if (params) {
    Object.keys(params).forEach(function (k) {
      if (params[k]) {
        // prevent from adding undefined value
        pieces.push("".concat(k, "=").concat(params[k]));
      }
    });
  }
  return axiosInstance.get("/api/grades/grading_schemes?".concat(pieces.join('&')));
};